<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <MenuCard :menuItems="visibleMenuItems" />
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import MenuCard from "@/components/MenuCard";
import { sessionHelper } from "@/utils";

export default {
  page: {
    title: i18n.t("module.administration"),
  },
  components: { Layout, PageHeader, MenuCard },
  computed: {
    visibleMenuItems() {
      const user = this.$store.state.api.auth.user?.user;
      const permissions = sessionHelper.getUserPermissions(
        user?.permissions,
        user?.isSuperadmin,
      );
      return this.menuItems.filter(
        (item) =>
          item.route !== "UserPermissionDefinition" ||
          (permissions.developer || 0) >= 1 ||
          (permissions.user_admin || 0) >= 1,
      );
    },
  },
  data() {
    return {
      title: i18n.t("module.administration"),
      items: [
        {
          text: i18n.t("module.administration"),
          active: true,
        },
      ],
      menuItems: [
        {
          route: "User",
          label: i18n.t("module.user"),
          icon: "mdi-account-multiple",
          color: "info",
          core: true,
        },
        {
          route: "PhoneExtension",
          label: "Phone Extention",
          icon: "mdi-phone",
          color: "success",
          core: true,
        },
        {
          route: "TeamDirectory",
          label: "Team Directory",
          icon: "mdi-contacts-outline",
          color: "warning",
          externalLink: true,
          core: true,
        },
        {
          route: "EsgDocument",
          label: i18n.t("module.esgDocument"),
          icon: "mdi-file-document-outline",
          color: "secondary",
          core: true,
        },
        {
          route: "UserPermissionDefinition",
          label: i18n.t("module.userPermissionDefinition"),
          icon: "mdi-shield-key-outline",
          color: "success",
          core: false,
        },
        {
          route: "UserRole",
          label: i18n.t("module.userRole"),
          icon: "mdi-account-key-outline",
          color: "primary",
          core: false,
        },
      ],
    };
  },
};
</script>
